import React from "react";
import BondBasicInformationBase from "../../shared/components/BondBasicInformationBase";
import { BOND_BASIC_INFO_CONFIG } from "../../shared/bondBasicInformationConfig";
import { BOND_STEP_BASIC_TRUSTEE_GUARDIANSHIP } from "../../shared/bondWizardStepPropTypes";

const BasicInformation = (props) => (
  <BondBasicInformationBase config={BOND_BASIC_INFO_CONFIG.guardianship} {...props} />
);

BasicInformation.propTypes = BOND_STEP_BASIC_TRUSTEE_GUARDIANSHIP;

export default BasicInformation;
